var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentInterestFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.588 21.413c.391.391.862.587 1.412.587a1.93 1.93 0 001.413-.587A1.93 1.93 0 0014 20h-4c0 .55.196 1.021.588 1.413zM8 15.845a7.642 7.642 0 01-2.487-2.595A7.275 7.275 0 014.5 9.5c0-2.083.73-3.854 2.188-5.312C8.146 2.729 9.917 2 12 2s3.854.73 5.312 2.188C18.771 5.646 19.5 7.417 19.5 9.5c0 1.35-.337 2.6-1.012 3.75A7.65 7.65 0 0116 15.845V18H8v-2.155z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentInterestFill);
export default __webpack_public_path__ + "c194a1c61ca2110d7d67afcf3fb561a8.svg";
export { ForwardRef as ReactComponent };